import React from "react";
import { LEGACY, COMPANY } from "../data/content";
import { AccentHeadline } from "../components/AccentHeadline";

export default function LegacyAssets() {
  return (
    <div data-testid="page-legacy">
      <section className="bg-[#14110E] text-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-24">
          <div className="eyebrow text-[#F26A1B] flex items-center gap-3">
            <span className="rule-orange" /> {LEGACY.eyebrow}
          </div>
          <h1 className="mt-6 font-display font-semibold text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight max-w-4xl">
            <AccentHeadline text={LEGACY.headline} accent={LEGACY.headlineAccent} />
          </h1>
          <p className="mt-8 text-[#F5F2EB] leading-relaxed max-w-3xl">{LEGACY.lead}</p>
          <div className="mt-8 inline-block border border-[#F26A1B] px-5 py-3 font-mono text-xs uppercase tracking-[0.22em] text-[#F26A1B]">
            Prior operating name: {COMPANY.formerName}
          </div>
        </div>
      </section>

      {/* Combined therapeutic approach */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <h2 className="font-display text-3xl lg:text-4xl text-[#14110E] font-semibold tracking-tight max-w-3xl" data-testid="legacy-approach-title">
          {LEGACY.combinedApproach.title}
        </h2>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="eyebrow text-[#F26A1B] flex items-center gap-3">
              <span className="rule-orange" /> Origin study
            </div>
            <h3 className="mt-6 font-display text-2xl lg:text-3xl text-[#14110E] font-semibold">
              {LEGACY.groundbreaking.title}
            </h3>
          </div>
          <div className="lg:col-span-7">
            <p className="text-[#4A3D30] leading-relaxed" data-testid="legacy-groundbreaking-body">
              {LEGACY.groundbreaking.body}
            </p>
          </div>
        </div>
      </section>

      {/* Follow-up + stats */}
      <section className="bg-[#F4F1EA] border-y border-[#DED6C6]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            <div className="lg:col-span-5">
              <div className="eyebrow text-[#F26A1B] flex items-center gap-3">
                <span className="rule-orange" /> Follow-up
              </div>
              <h3 className="mt-6 font-display text-2xl lg:text-3xl text-[#14110E] font-semibold">
                {LEGACY.followUp.title}
              </h3>
              <p className="mt-6 text-[#4A3D30] leading-relaxed">{LEGACY.followUp.body}</p>
            </div>
            <div className="lg:col-span-7">
              <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-[#DED6C6] border border-[#DED6C6]">
                {LEGACY.followUp.stats.map((s, i) => (
                  <div key={i} className="bg-white p-6 lg:p-7" data-testid={`legacy-stat-${i}`}>
                    <div className="font-display text-4xl lg:text-5xl text-[#F26A1B] font-semibold leading-none tracking-tight">
                      {s.pct}
                    </div>
                    <p className="mt-4 text-xs lg:text-sm text-[#4A3D30] leading-relaxed">{s.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Combined treatment */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="eyebrow text-[#F26A1B] flex items-center gap-3">
              <span className="rule-orange" /> Formulation
            </div>
            <h3 className="mt-6 font-display text-2xl lg:text-3xl text-[#14110E] font-semibold">
              {LEGACY.combined.title}
            </h3>
          </div>
          <div className="lg:col-span-7">
            <p className="text-[#4A3D30] leading-relaxed" data-testid="legacy-combined-body">
              {LEGACY.combined.body}
            </p>
          </div>
        </div>
      </section>

      {/* Phase 2 */}
      <section className="bg-[#14110E] text-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            <div className="lg:col-span-5">
              <div className="eyebrow text-[#F26A1B] flex items-center gap-3">
                <span className="rule-orange" /> Clinical program
              </div>
              <h3 className="mt-6 font-display text-2xl lg:text-3xl font-semibold">
                {LEGACY.phase2.title}
              </h3>
              <p className="mt-6 text-[#F5F2EB] leading-relaxed">{LEGACY.phase2.body}</p>
            </div>
            <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
              {LEGACY.phase2.advantages.map((a, i) => (
                <div key={i} className="border border-[#3A2E22] p-6" data-testid={`legacy-adv-${i}`}>
                  <div className="font-mono text-xs tracking-[0.22em] text-[#F26A1B]">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <h4 className="mt-3 font-display text-lg font-semibold">{a.title}</h4>
                  <p className="mt-2 text-sm text-[#F5F2EB] leading-relaxed">{a.body}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Pathways */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="eyebrow text-[#F26A1B] flex items-center gap-3">
          <span className="rule-orange" /> Portfolio pathways
        </div>
        <h2 className="mt-6 font-display text-3xl lg:text-4xl text-[#14110E] font-semibold tracking-tight max-w-3xl">
          Technology portfolio pathways
        </h2>
        <p className="mt-6 text-[#4A3D30] leading-relaxed max-w-3xl">
          Trafalgar International, Inc. may pursue multiple pathways for the development and monetization of its
          current and future intellectual property, depending on market conditions, available resources, strategic
          fit, and commercial potential.
        </p>
        <div className="mt-10 flex flex-wrap gap-2">
          {LEGACY.pathways.map((p) => (
            <span
              key={p}
              className="px-4 py-2 border border-[#14110E] text-[13px] text-[#14110E] tracking-wide"
              data-testid={`legacy-pathway-${p.replace(/\s+/g,"-").toLowerCase()}`}
            >
              {p}
            </span>
          ))}
        </div>
      </section>
    </div>
  );
}
